import React from 'react';
import {AlertDanger} from '@homeaway/react-alerts';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import PropTypes from 'prop-types';

const DefaultErrorComponent = ({messages, reloadOptions, reload}) => {
    return (
        <AlertDanger title={messages.title} msg={messages.msg}>
            {reloadOptions.onReload && (
                <p>
                    <ButtonPrimary
                        label={messages['btn.label']}
                        onClick={reload}
                        size="sm"
                        disabled={reloadOptions.loading}
                    >
                        <LoadingOverlay loading={reloadOptions.loading} />
                    </ButtonPrimary>
                </p>
            )}
        </AlertDanger>
    );
};

DefaultErrorComponent.proptypes = {
    messages: PropTypes.shape({
        title: PropTypes.string,
        msg: PropTypes.string,
        'btn.label': PropTypes.string,
    }),
    reload: PropTypes.func,
    reloadOptions: PropTypes.shape({
        loading: PropTypes.bool,
        onReload: PropTypes.func,
    }),
};

export default DefaultErrorComponent;
